import { render } from "./AssignNotificationDialog.vue?vue&type=template&id=5400bd3a&ts=true"
import script from "./AssignNotificationDialog.ts?vue&type=script&lang=ts"
export * from "./AssignNotificationDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__